/**
 * Parse an integer query/param value, with fallback for non-numeric input.
 * Mirrors the server-side helper to keep client + server consistent.
 */
export function parseIntParam(
  value: string | number | undefined | null,
  fallback: number,
): number {
  if (value === undefined || value === null || value === '') return fallback
  const n = typeof value === 'number' ? value : parseInt(value, 10)
  return Number.isFinite(n) ? n : fallback
}

export function clampInt(
  value: string | number | undefined | null,
  min = 1,
  max = 100,
  fallback: number = min,
): number {
  const n = parseIntParam(value, fallback)
  return Math.min(max, Math.max(min, n))
}
